import { computed } from 'vue';
import { useAuthenticated } from '@othercommerce/foundation';
import { Features } from '@shared/features';

export function useCustomerAccepted() {
  const authenticated = useAuthenticated();

  return computed(() => {
    if (!authenticated.value) {
      return undefined;
    }

    if (Features.forceAuthenticatedAndAccepted.isEnabled) {
      return (
        !!authenticated.value.emailVerifiedAt &&
        !!authenticated.value.acceptedAt
      );
    }

    return undefined;
  });
}
